<template>
  <div>
    <campaign-creator-profile :creator-display-name="creatorDisplayName" :profile-image="profileImage"
                              :label="label" :campaigner-contactable="campaignerContactable"
                              class="creator-profile" :class="{contactable: campaignerContactable}"
                              @click="openContactFormIfEnabled" />
    <contact-message-modal v-if="campaignerContactable" ref="modal" :create-path="contactPath" :title="modalTitle"
                           :current-user="currentUser" :data-processing-consent="dataProcessingConsent" />
  </div>
</template>

<script>
import CampaignCreatorProfile from './campaign-creator-profile'
import ContactMessageModal from '@/components/contact-message-modal'

const CONTACT_CAMPAIGNER_URL_FRAGMENT = '#contact-campaigner'

export default {
  components: { CampaignCreatorProfile, ContactMessageModal },

  props: {
    campaignerContactable: {
      type: Boolean,
      required: true
    },
    contactPath: {
      type: String,
      required: false
    },
    creatorDisplayName: {
      type: String,
      required: true
    },
    currentUser: {
      type: Object,
      required: false
    },
    dataProcessingConsent: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    profileImage: {
      type: Object,
      required: false
    }
  },

  computed: {
    modalTitle() {
      return this.i18n.t('public.contact.contact_user', {user_name: this.creatorDisplayName})
    }
  },

  mounted() {
    // If the URL has #contact-campaigner, automatically open the contact form on page load
    const currentUrl = new URL(window.location.href)
    if (currentUrl.hash === CONTACT_CAMPAIGNER_URL_FRAGMENT) {
      this.openContactFormIfEnabled()
    }
  },

  methods: {
    openContactFormIfEnabled() {
      if (this.campaignerContactable) {
        this.$refs.modal.open()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.creator-profile.contactable {
  cursor: pointer;

  &:hover {
    ::v-deep(.btn-link) {
      text-decoration: underline;
    }
  }
}
</style>
